module.exports = __webpack_public_path__ + "img/auditor-good-news.f3834cca.svg";